import * as main from "../vendors/SagaSystem/boot/main"

main.default(import("./../Application"))
